import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import socketService from '../services/socketService';
import { useParams } from 'react-router-dom';
import { getUserBusinessGroupIdFromAccessToken } from '../utils/jwtPayload';

export function usePosSocket(posId) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { businessSlug } = useParams();
  const [posIdState, setPosIdState] = useState(posId);

  useEffect(() => {
    if (posId !== posIdState) {
      setPosIdState(posId);
    }
  }, [posId, posIdState]);

  useEffect(() => {
    let cleanupHandler = null;
    if (posIdState) {
      if (!socketService.socket) {
        socketService.connect();
      }

      socketService.setPosChannel(posIdState);
      console.log('เริ่มต้นการตรวจสอบ POS จาก server : ', posIdState);

      cleanupHandler = socketService.registerPosLogoutHandler(
        () => {
          console.log('ได้รับคำสั่ง logout จาก POS server');
          localStorage.removeItem('branchPOSId');
          localStorage.removeItem('email');
          localStorage.removeItem('branchId');
          localStorage.removeItem('branchPOSSelling');
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          socketService.disconnect();
          navigate(`/${businessSlug}/login`, { replace: true });
        },
        () => getUserBusinessGroupIdFromAccessToken(),
      );
    }

    return () => {
      if (cleanupHandler) {
        cleanupHandler();
      }
    };
  }, [posIdState, dispatch, navigate, businessSlug]);
}
